import ComponentManager from '@/Management/ComponentManager';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import { ICustomSingleDropDown, ICustomDropDownItemDTO } from '#/DefaultViewExtensionInterfaces';
import CustomDropDownHelper from '@/Components/CustomDropDown/CustomDropDownHelper';

export default class CustomSingleDropDownViewModel extends DropDownListViewModel implements ICustomSingleDropDown {
    private dropDownHelper: CustomDropDownHelper<this>;
    public data: KnockoutComputed<ICustomDropDownItemDTO[]>;
    public value: KnockoutComputed<string>;

    constructor(protected readonly params: any) {
        super($.extend(params,
            {
                dataValueField: 'Identifier',
                dataTextField: 'DisplayName'
            }
        ));

        this.createHelperIfNeccessary();
    }

    /**
     * Creates helper if neccessary
     */
    private createHelperIfNeccessary() {
        if (this.dropDownHelper == null)
            this.dropDownHelper = new CustomDropDownHelper(this, this.params.dto);
    }

    /**
     * Safe access to helper (from parent constructor)
     */
    private getHelper(): CustomDropDownHelper<this> {
        this.createHelperIfNeccessary();
        return this.dropDownHelper;
    }
    
    /**
     * @override 
     */
    protected createData(): KnockoutComputed<ICustomDropDownItemDTO[]> {
        return this.getHelper().createData();
    }

    /**
     * @override 
     */
    protected createValue(): KnockoutObservable<string> {
        return this.getHelper().createValue<string>(false);
    }
}

ComponentManager.setViewModel('CustomSingleDropDown', CustomSingleDropDownViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');